var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRow',{attrs:{"fill-height":"","align-center":"","row":"","wrap":""}},[_c('VCol',{staticClass:"card-paragraph",style:({
      marginBottom: '6px',
      paddingLeft: '16px'
    }),attrs:{"cols":"12"}},[_c('CardTitle',{attrs:{"has-images":_vm.hasImages,"align":"left"}},[_vm._v(" "+_vm._s(_vm.card.name)+" ")]),_c('p',{directives:[{name:"linkified",rawName:"v-linkified"}],staticClass:"subheading formatted",staticStyle:{"overflow-y":"auto"},domProps:{"innerHTML":_vm._s(_vm.card.value)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }